// extracted by mini-css-extract-plugin
module.exports = {"noCoversations":"HomeMessages_noCoversations__aYV61","notification":"HomeMessages_notification__9wP0p"};